/*! DivaRouj v10.3 — Third-Party Rehydrate (GTM/Facebook/Ads/Avada)
   Goal: cut TBT by deferring known third-party scripts rendered in content_for_header.
   Mechanism: theme.liquid rewrites matching <script src="..."> into type="text/plain" data-diva-src="..."
   This file loads them after idle or first user interaction (whichever comes first).
*/
(function () {
  'use strict';

  var loaded = false;

  function onIdle(cb) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { cb(); }, { timeout: 2500 });
    } else {
      setTimeout(cb, 1200);
    }
  }

  function loadOne(node) {
    try {
      var src = node.getAttribute('data-diva-src');
      if (!src) return;

      var s = document.createElement('script');
      // Preserve important attrs when present
      var nonce = node.getAttribute('nonce');
      if (nonce) s.setAttribute('nonce', nonce);

      // Do NOT async=false; keep default async true for 3P
      s.async = true;
      s.src = src;

      // Insert near original to preserve ordering as much as possible
      node.parentNode.insertBefore(s, node.nextSibling);
      node.parentNode.removeChild(node);
    } catch (e) {
      // fail silently
    }
  }

  function rehydrate() {
    if (loaded) return;
    loaded = true;

    var nodes = document.querySelectorAll('script[data-diva-src][type="text/plain"]');
    if (!nodes || !nodes.length) return;

    for (var i = 0; i < nodes.length; i++) loadOne(nodes[i]);
  }

  function firstInteraction() {
    rehydrate();
    window.removeEventListener('scroll', firstInteraction, { passive: true });
    window.removeEventListener('pointerdown', firstInteraction, { passive: true });
    window.removeEventListener('keydown', firstInteraction, { passive: true });
    window.removeEventListener('touchstart', firstInteraction, { passive: true });
  }

  // 1) Prefer idle load (best for performance)
  onIdle(rehydrate);

  // 2) But guarantee load on first real user interaction
  window.addEventListener('scroll', firstInteraction, { passive: true, once: true });
  window.addEventListener('pointerdown', firstInteraction, { passive: true, once: true });
  window.addEventListener('keydown', firstInteraction, { passive: true, once: true });
  window.addEventListener('touchstart', firstInteraction, { passive: true, once: true });

  // 3) Safety net (in case of no idle + no interaction)
  setTimeout(rehydrate, 6000);
})();
